import { useEffect } from 'react'

const BASE_TITLE = 'PicField'
const PICFIELD_FAVICON = '/logo-picfield.png'

function getFaviconLinks(): HTMLLinkElement[] {
  return Array.from(
    document.querySelectorAll<HTMLLinkElement>('link[rel="icon"], link[rel="apple-touch-icon"]')
  )
}

export default function usePicFieldTitle(subtitle?: string | null) {
  useEffect(() => {
    const previousTitle = document.title
    document.title = subtitle ? `${BASE_TITLE} - ${subtitle}` : BASE_TITLE

    const links = getFaviconLinks()
    const previousHrefs = links.map(link => link.href)
    links.forEach(link => { link.href = PICFIELD_FAVICON })

    return () => {
      document.title = previousTitle
      links.forEach((link, i) => { link.href = previousHrefs[i] })
    }
  }, [subtitle])
}
